module.exports = __webpack_public_path__ + "img/ftth_index05.11334629.jpg";